import React from 'react';

export default function OpenHours() {
    return (
        <div className="widget open-hours justify-left">
            <h2 className="widget--title white uppercase">Open Hours</h2>

            <ul>
                <li className="open-hours--row">
                    Monday - Friday
                    <span className="highlight">7:00am - 7:00pm</span>
                </li>
                <li className="open-hours--row">
                    Saturday
                    <span className="highlight">8:00am - 2:00pm</span>
                </li>
                <li className="open-hours--row">
                    Sunday
                    <span className="highlight">Closed</span>
                </li>
            </ul>
        </div>
    )
};
